export enum Target {
    Self = "_self",
    Blank = "_blank"
}



export function openLink(url: string, target?: Target) {
    const link = document.createElement('a');
    
    if(target !== undefined)
        link.target = target;
    else 
        link.target = Target.Self;
    
    link.href = url;
    link.setAttribute('visibility', 'hidden');
    link.click();
}

export const WEBSITEURL = "../clampex/#/"